enum WebserviceUrlConverterFields {
	ENABLED = "urlconverter_enabled",
	INSTANCES = "urlconverter_instances",
	QUEUE = "urlconverter_queue",
	LATENCY = "urlconverter_latency",
	TIMEOUT = "urlconverter_timeout",
}

export default WebserviceUrlConverterFields;